export default function version() {
	console.log("Madnes version: 22.0.12");
	console.log("Madnes commit: 1e08dc19");
	console.log("JB version: 1.2.0");
	console.log("JB commit: bdbf796")
	console.log("Game version: 26.44.01-beta-379726");
	console.log("Build date: Wed Nov  4 22:06:16 UTC 2026");
	console.log("Git commit: fad43468");
	console.log("Git commit date: 2026-11-04T23:01:14+01:00");
}